var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20215 4.45692V2.61506C6.20215 1.88201 6.80193 1.28223 7.53498 1.28223H14.4658C15.1989 1.28223 15.7986 1.88201 15.7986 2.61506V4.45692",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1413 10.4131V17.476C20.1413 18.1584 19.5828 18.7169 18.9004 18.7169H3.09932C2.41694 18.7169 1.8584 18.1585 1.8584 17.476V10.4545",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34544 12.5019C4.96957 12.2517 1.03125 11.0004 1.03125 8.74796V5.81124C1.03125 5.12778 1.58867 4.57031 2.27217 4.57031H19.7278C20.4113 4.57031 20.9687 5.12782 20.9687 5.81124V8.74796C20.9687 11.0145 16.9807 12.2673 12.5718 12.5065",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46973 11.2715H12.5307V12.6985C12.5307 13.4834 11.8885 14.1256 11.1036 14.1256H10.8968C10.1119 14.1256 9.46973 13.4834 9.46973 12.6985V11.2715Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFileImg);
export default __webpack_public_path__ + "static/media/dashboard-file-img.0ad0e700050925646f7e0ccac95f31c0.svg";
export { ForwardRef as ReactComponent };